// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"123":"cea361e3","371":"10616914","755":"e4290d7b","941":"a928fb39"}[chunkId] + ".chunk.css";
};